import { getPathWithoutSlash } from 'libs';
import {
  INDEX,
  PRODUCTS,
  SECURITYSETTINGS,
  SETTLEMENTSETTINGS,
  TRANSACTIONS,
  WALLET,
} from 'router/routes';
import { ReducerRegistry } from 'store';
import { SHOW_TOAST, HIDE_TOAST } from '../types';

const init_State = {
  isFirstTime: true,
  run: false,
  loading: false,
  stepIndex: 0,
  debug: false,
  path: null,
  steps: [
    {
      disableBeacon: true,
      target: '#' + getPathWithoutSlash(INDEX),
      hideCloseButton: true,
      content:
        'You can now see everything about your business at a glance. The Overview page has a graph, and details of your sales per time. ',
      nextPath: INDEX,
    },
    {
      disableBeacon: true,
      target: '#activateCard',
      hideCloseButton: true,
      content:
        'You can now see everything about your business at a glance. The Overview page has a graph, and details of your sales per time. ',
      nextPath: PRODUCTS,
    },
    {
      disableBeacon: true,
      hideCloseButton: true,
      target: '#create-product-button-list',
      content:
        'To be able to make sales, you need to create a product on Marketplace. Create your product(onboard customers and collect payment) easily via our Agent network. Add your product details, add your onboarding details, amount and any other fields that interest you.',
      nextPath: TRANSACTIONS,
    },
    {
      hideCloseButton: true,
      disableBeacon: true,
      target: '#' + getPathWithoutSlash(TRANSACTIONS),
      content:
        'Every transaction shows up here and you can filter by time or status. You can even customise your fields to suite your business. ',
      nextPath: WALLET,
    },
    {
      hideCloseButton: true,
      disableBeacon: true,
      target: '#' + getPathWithoutSlash(WALLET),
      content:
        'Every transaction in and out of you wallet shows up here. This allows you see inflows and outflows from your merchant wallet. You can also fund or withdraw from your wallet directly from here.',
      nextPath: SECURITYSETTINGS,
    },
    {
      hideCloseButton: true,
      disableBeacon: true,
      target: '#set-authentication-pin',
      content:
        "You need to set your Authentication PIN to authorise any payment or changes to your account. Kindly ensure your PIN is safe and don't reveal to just anyone.",
      nextPath: SETTLEMENTSETTINGS,
    },
    {
      hideCloseButton: true,
      disableBeacon: true,
      target: '#set-bank-details',
      content:
        'Set up your Settlement Bank Account(s), so we can settle you into your bank account of your chosen at any time you choose. ',
    },

    {
      hideCloseButton: true,
      disableBeacon: true,
      target: '#set-settlement-details',
      content:
        'Set up what time and schedule you want to be settled into your bank account. We suggest you choose  1 Day after Transaction Day.',
    },
  ],
  // : [
  //     {
  //       disableBeacon: true,
  //       target: '#' + getPathWithoutSlash(INDEX),
  //       hideCloseButton: true,
  //       content:
  //         'You can now see everything about your business at a glance. The Overview page has a graph, and details of your sales per time. ',
  //     },
  //     {
  //       hideCloseButton: true,
  //       target: '#activateCard',
  //       content: `Fill in details of the owner of the business and business details here to access your dashboard. Till you activate your account, you can't enjoy the experience waiting for you.`,
  //     },
  //   ],
};

export const state = ReducerRegistry.register(
  'tour',
  (state = init_State, action) => {
    switch (action.type) {
      case 'START':
        return { ...state, run: true, ...action.payload };
      case 'RESET':
        return { ...state, stepIndex: 0 };
      case 'STOP':
        return { ...state, run: false, isFirstTime: false, stepIndex: 0 };
      case 'NEXT_OR_PREV':
        return { ...state, ...action.payload };
      case 'RESTART':
        return {
          ...state,
          stepIndex: 0,
          run: true,
          loading: false,
          key: new Date(),
        };
      default:
        return state;
    }
  },
);
